import { css } from "@emotion/react";

import { useTheme } from "./theme/hooks";

export default function Divider() {
    const theme = useTheme();
    return (
        <div
            css={css({
                height: "1px",
                backgroundColor: theme.divider,
            })}
        />
    );
}
